/* eslint-disable */

import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import qDocPromise from 'config/qDoc';
import Filter from 'components/Filter/Filter';
import Search from 'components/Search/Search';
import TablePriceGuide from 'components/TablePriceGuide/TablePriceGuide';
import SelectedOffers from 'components/SelectedOffers/SelectedOffers';
import { SelectedOffersContext } from '../../SelectedOffersContext';
import { UserContext } from '../../UserContext';
import styles from './styles';

class PriceGuideAlt extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
  };

  state = {
    qDocLoaded: false,
    selectedDate: null,
    productsSearchString: '',
    servicesSearchString: '',
    selectedCurrency: null,
    selectedServiceCurrency: null,
    drawerOpen: true,
    selectedTab: 'Products',
    clearTrigger: false,
    showTable: true,
    error: '',
    selectionInProgress: false, 
    // Separate sorting for each tab
    sortState: {
      products: { sortColumn: 0, sortDirection: 'asc' },
      services: { sortColumn: 0, sortDirection: 'asc' },
    },
  };

  commonCurrencies = ['AUD', 'BRL', 'CAD', 'CHF', 'CNY', 'DKK', 'EUR', 'GBP', 'HKD', 'JPY', 'KRW', 'MXN', 'NOK', 'NZD', 'SEK', 'SGD', 'USD'];

  componentDidMount() {
    this.awaitQDoc();
    window.addEventListener('resize', this.handleResize);
    this.handleResize(); // Check initial size
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  setProductsSearchString = (productsSearchString) => {
    this.setState({ productsSearchString });
  }

  setServicesSearchString = (servicesSearchString) => {
    this.setState({ servicesSearchString });
  }

  setDateAndCurrency = async () => {
    // Prevent multiple selections at once
    if (this.state.selectionInProgress) return;
  
    try {
      this.setState({ selectionInProgress: true }); // Lock selection while processing
  
      const qDoc = await qDocPromise;
      const selectedDate = await qDoc.evaluateEx('only({<[Month Year]=P()>} [Month Year])');
      const selectedCurrency = await qDoc.evaluateEx('only({<[Currency]=P()>} Currency)');
      const selectedServiceCurrency = await qDoc.evaluateEx('only({<[Service_Currency]=P()>} Service_Currency)');
  
      let latestMonthYear = { qText: null };
  
      if (!selectedDate.qText || selectedDate.qText === '-') {
        latestMonthYear = await qDoc.evaluateEx('Date(only([Default Date]), \'MMMM YYYY\')');
        if (!latestMonthYear.qText || latestMonthYear.qText === '-') {
          throw new Error("No available Month Year found in data.");
        }
        const monthYearField = await qDoc.getField('[Month Year]');
        await monthYearField.select(latestMonthYear.qText);
      }
  
      this.setState({
        selectedDate: selectedDate.qText || latestMonthYear.qText,
        selectedCurrency: selectedCurrency.qText,
        selectedServiceCurrency: selectedServiceCurrency.qText,
        error: null,
      });
    } catch (error) {
      console.error("Error selecting Month Year: ", error);
      if (this.state.qDocLoaded) {
        this.setState({ error: "Unable to select the latest Month Year. Please check your data." });
      }
    } finally {
      this.setState({ selectionInProgress: false }); // Unlock selection after completion
    }
  };


    awaitQDoc = async () => {
      try {
        const qDoc = await qDocPromise;

        // Ensure Month Year is selected
        const latestMonthYear = await qDoc.evaluateEx('Date(only([Default Date]), \'MMMM YYYY\')');

        if (!latestMonthYear.qText || latestMonthYear.qText === '-') {
          throw new Error("No available Month Year found in data.");
        }

        const monthYearField = await qDoc.getField('[Month Year]');
        await monthYearField.select(latestMonthYear.qText);

        await this.setDateAndCurrency(); // Ensure the latest date is set before loading

        const currencyField = await qDoc.getField('[Currency]');
        const serviceCurrencyField = await qDoc.getField('[Service_Currency]');

        monthYearField.on('changed', this.setDateAndCurrency);
        currencyField.on('changed', this.setDateAndCurrency);
        serviceCurrencyField.on('changed', this.setDateAndCurrency);

        this.setState({ qDocLoaded: true, error: null }); // Clear any previous errors
      } catch (e) {
        console.error('There was an error selecting the Month Year field: ', e);
        this.setState({ error: "There was an error fetching the data. Please try again." });
      }
    };

  toggleDrawer = () => {
    this.setState((prevState) => ({ drawerOpen: !prevState.drawerOpen }));
  };

  handleResize = () => {
    const screenWidth = window.innerWidth;
    this.setState({
      screenWidth,
      drawerOpen: screenWidth < 1060 ? true : this.state.drawerOpen, // Keep drawer open for small screens
    });
  };

  handleTabChange = (tab) => {
    this.setState({ selectedTab: tab });
  };

  clearAllSelections = async (clearAllItems) => {
    this.setState({ qDocLoaded: false, error: null }); // Temporarily disable error display
  
    const qDoc = await qDocPromise;
  
    try {
      const currentCurrency = this.state.selectedCurrency;
      const currentServiceCurrency = this.state.selectedServiceCurrency;
  
      // Clear Qlik selections
      await qDoc.clearAll();
  
      if (currentCurrency && currentServiceCurrency) {
        const currencyField = await qDoc.getField('[Currency]');
        await currencyField.select(currentCurrency);
        const serviceCurrencyField = await qDoc.getField('[Service_Currency]');
        await serviceCurrencyField.select(currentServiceCurrency);
  
        const maxMonthYear = await qDoc.evaluateEx('Date(only([Default Date]), \'MMMM YYYY\')');
        const monthYearField = await qDoc.getField('[Month Year]');
        await monthYearField.select(maxMonthYear.qText);
      }
  
      // Clear all selected items
      clearAllItems();
  
      // Ensure selections are complete before running setDateAndCurrency
      setTimeout(() => {
        this.setDateAndCurrency(); // Ensure the right Month Year is selected
        this.setState({ qDocLoaded: true, error: null }); // Clear any temporary error
      }, 500); // Short delay to allow selections to complete
    } catch (error) {
      console.error('Error clearing selections:', error);
      this.setState({ error: "There was an issue resetting selections. Please try again." });
    }
  };

  handleCurrencyChange = async (selectedCurrency, type) => {
    const qDoc = await qDocPromise;
  
    const { commonCurrencies } = this;
    const isCommon = commonCurrencies.includes(selectedCurrency);
  
    if (qDoc) {
      try {
        this.setState({ selectionInProgress: true }); // Lock while selecting currency
  
        const productsCurrencyField = await qDoc.getField('[Currency]');
        const servicesCurrencyField = await qDoc.getField('[Service_Currency]');
  
        if (type === 'Services') {
          await productsCurrencyField.select(selectedCurrency);
          this.setState({ showTable: true });
        } else if (type === 'Products' && isCommon) {
          await servicesCurrencyField.select(selectedCurrency);
          this.setState({ showTable: true });
        } else {
          await servicesCurrencyField.clear();
          this.setState({ showTable: false });
        }
  
        // Wait until currency selection is done before updating Month Year
        setTimeout(() => {
          this.setDateAndCurrency();
        }, 500);
      } catch (error) {
        console.error("Error selecting currency:", error);
      } finally {
        this.setState({ selectionInProgress: false });
      }
    }
  };

  handleRefresh = () => {
    // Refresh the page
    this.setState({ error: null })
    window.location.reload();
  }

  handleSort = (columnIndex) => {
    this.setState((prevState) => {
      const selectedTab = prevState.selectedTab.toLowerCase(); // 'products' or 'services'
      const prevSort = prevState.sortState[selectedTab];
  
      return {
        sortState: {
          ...prevState.sortState,
          [selectedTab]: {
            sortColumn: columnIndex,
            sortDirection: prevSort.sortColumn === columnIndex && prevSort.sortDirection === 'asc' ? 'desc' : 'asc',
          },
        },
      };
    });
  };

  render() {
    const { classes } = this.props;
    const { selectedDate, drawerOpen, selectedTab, productsSearchString, servicesSearchString, selectedCurrency, showTable, qDocLoaded, error } = this.state;
    return (
      <div className={classes.container}>
        {!qDocLoaded && (
          <div className={classes.overlay}>
            <div className={classes.loaderIcon}></div>
          </div>
        )}

        {/* Error Popup */}
        {error && (
          <div className={classes.errorPopup}>
            <p>{error}</p>
            <button onClick={this.handleRefresh}>Refresh</button>
          </div>
        )}

        {qDocLoaded && (
          <SelectedOffersContext.Consumer>
            {({ selectedItems, updateItem, removeItem, clearAllItems }) => (
              <UserContext.Consumer>
                {(userObject) => {

                  const isPartner = (
                    userObject &&
                    userObject.user &&
                    userObject.user.level === 'partner'
                  );
                  
                  return (
                    <div>
                    <section className={classes.intro}>
                      <span
                        style={{
                          display: 'inline-block',
                          width: '100%',
                          color: '#5d5d5d',
                          fontStyle: 'italic',
                        }}
                      >
                        Prices as of: {selectedDate}
                      </span>
                      <div className={classes.btnsWrapper}>
                      <button
                        className={classes.clearAllButton}
                        onClick={() => this.clearAllSelections(clearAllItems)}
                      >
                        Clear All
                      </button>

                      {!isPartner && (
                        <div className={classes.btnCTAWrapper}>
                          <span>Have product questions?</span>
                          <a
                            className={classes.btnFilled}
                            href="https://salesai.qliktech.com/"
                            target="_blank"
                            rel="noreferrer"
                          >
                            Ask Sales AI
                          </a>
                        </div>
                      )}

                    </div>
                    </section>
    
                    {/* Tab Switcher */}
                    <div className={classes.tabSwitcher}>
                        <div className={classes.tabs}>
    
                        <button
                        className={`${classes.tabButton} ${
                          selectedTab === 'Products' ? classes.activeTab : ''
                        }`}
                        onClick={() => this.handleTabChange('Products')}
                      >
                        Products / Capabilities
                      </button>
                      <button
                        className={`${classes.tabButton} ${
                          selectedTab === 'Services' ? classes.activeTab : ''
                        }`}
                        onClick={() => this.handleTabChange('Services')}
                      >
                        Services
                      </button>
                    </div>
                    </div>
    
                    <section
                      className={classes.priceGuide}
                      style={{
                        gridTemplateColumns: drawerOpen ? '1fr 500px' : '1fr',
                      }}
                    >
                      <button
                        className={classes.drawerToggle}
                        onClick={this.toggleDrawer}
                        style={{
                          backgroundColor: drawerOpen ? '#f2f2f2' : '#009845',
                          color: drawerOpen ? '#414141' : '#FFFFFF',
                        }}
                      >
                        {drawerOpen ? 'Hide Offers ❯' : '❮ Show Offers'}
                      </button>
                      <div className={classes.leftSide}>
                        <div className={classes.mobileOnly}>
                          <p>
                            Viewing this on a small screen? Make your selections and scroll down to view
                            your Selected Offers.
                          </p>
                        </div>
    
                        {/* PRODUCTS */}
                        {selectedTab === 'Products' && (
                          <div className={classes.productsSection}>
                            <section className={classes.filtersWrapper}>
                              <div className={classes.sectionHeaderWrapper}>
                                <div
                                  className={classes.currencyFilterContainer}
                                  style={{ marginRight: drawerOpen ? 0 : '120px' }}
                                >
                                  <div className={classes.introText}>
                                    <p>
                                      Use the filters to customize your search and find the products or services you
                                      need. Select items from the table to add them to your Selected Offers, where
                                      you’ll see the total price calculated. Once finalized, you can export your
                                      selections for easy reference.
                                    </p>
                                  </div>
                                  <div className={classes.currencyFilter}>
                                      <Filter
                                        field="[Currency]"
                                        title="Currency"
                                        titleShow={false}
                                        headerShow={false}
                                        dropdown
                                        overrideLock
                                        onChange={(currency) => this.handleCurrencyChange(currency, 'Products')}
                                        />
                                    </div>
                                </div>
                              </div>
                              <div className={classes.filters}>
                                <div className={classes.filter}>
                                  <Filter
                                    field="=Aggr(Only({<[Matrix Customer Type], [Matrix Product Category], [Matrix Sales Channel], [Matrix Deployment Model], [Matrix Edition], [Matrix Product/Capacity]>} [Matrix Customer Type]), [Matrix Customer Type])"
                                    title="Customer Type"
                                    toggleSelections
                                    selectType="multi"
                                  />
                                </div>
                                <div className={classes.filter}>
                                  <Filter
                                    field="=Aggr(Only({<[Matrix Customer Type], [Matrix Product Category], [Matrix Sales Channel], [Matrix Deployment Model], [Matrix Edition], [Matrix Product/Capacity]>} [Matrix Product Category]), [Matrix Product Category])"
                                    title="Product Category"
                                    toggleSelections
                                    selectType="single"
                                  />
                                </div>
                                <div className={classes.filter}>
                                  <Filter
                                    field="=Aggr(Only({<[Matrix Customer Type], [Matrix Product Category], [Matrix Sales Channel], [Matrix Deployment Model], [Matrix Edition], [Matrix Product/Capacity]>} [Matrix Sales Channel]), [Matrix Sales Channel])"
                                    title="Sales Channel"
                                    toggleSelections
                                    selectType="multi"
                                  />
                                </div>
                                <div className={classes.filter}>
                                  <Filter
                                    field="=Aggr(Only({<[Matrix Customer Type], [Matrix Product Category], [Matrix Sales Channel], [Matrix Deployment Model], [Matrix Edition], [Matrix Product/Capacity]>} [Matrix Deployment Model]), [Matrix Deployment Model])"
                                    title="Deployment Model"
                                    toggleSelections
                                    selectType="single"
                                  />
                                </div>
                                <div className={classes.filter}>
                                  <Filter
                                    field="=Aggr(Only({<[Matrix Customer Type], [Matrix Product Category], [Matrix Sales Channel], [Matrix Deployment Model], [Matrix Edition], [Matrix Product/Capacity]>} [Matrix Product/Capacity]), [Matrix Product/Capacity])"
                                    title="Product/Capacity"
                                    toggleSelections
                                    selectType="single"
                                  />
                                </div>
                                <div className={classes.filter}>
                                  <Filter
                                    field="=Aggr(Only({<[Matrix Customer Type], [Matrix Product Category], [Matrix Sales Channel], [Matrix Deployment Model], [Matrix Edition], [Matrix Product/Capacity]>} [Matrix Edition]), [Matrix Edition])"
                                    title="Edition"
                                    toggleSelections
                                    selectType="single"
                                  />
                                </div>
                              </div>
                            </section>
                            <div className={classes.searchBar}>
                              <Search searchString={productsSearchString} setSearchString={this.setProductsSearchString} />
                            </div>
                            <TablePriceGuide
                              selectedItems={selectedItems}
                              type="products"
                              clearTrigger={this.state.clearTrigger}
                              searchString={productsSearchString}
                              sortColumn={this.state.sortState.products.sortColumn}
                              sortDirection={this.state.sortState.products.sortDirection}
                              handleSort={this.handleSort}
                              isPartner = {isPartner}
                            />
                          </div>
                        )}
    
                        {/* SERVICES */}
                        {selectedTab === 'Services' && (
                          <div className={classes.servicesSection}>
                            <section className={classes.filtersWrapper}>
                              <div className={classes.sectionHeaderWrapper}>
                                <div
                                  className={classes.currencyFilterContainer}
                                  style={{ marginRight: drawerOpen ? 0 : '120px' }}
                                >
                                  <div className={classes.introText}>
                                    <p>
                                      Use the filters to customize your search and find the products or services you
                                      need. Select items from the table to add them to your Selected Offers, where
                                      you’ll see the total price calculated. Once finalized, you can export your
                                      selections for easy reference.
                                    </p>
                                  </div>
                                  <div className={classes.currencyFilter}>
                                    <Filter
                                      field="[Service_Currency]"
                                      title="Currency"
                                      titleShow={false}
                                      headerShow={false}
                                      dropdown
                                      overrideLock
                                      onChange={(currency) => this.handleCurrencyChange(currency, 'Services')}
    
                                    />
                                    {showTable === false && <div className={classes.warning}>{selectedCurrency} is not available.</div>}
                                  </div>
                                </div>
                              </div>
                              {
                                showTable && 
                                  <div className={classes.filters}>
                                    <div className={classes.filter}>
                                      <Filter
                                        field="=Aggr(Only({<[Service_Services Type], [Service_Customer Type], [Service_Product Specific], [Service_Product Category]>} [Service_Customer Type]), [Service_Customer Type])"
                                        title="Customer Type"
                                        toggleSelections
                                      />
                                    </div>
                                    <div className={classes.filter}>
                                      <Filter
                                        field="=Aggr(Only({<[Service_Services Type], [Service_Customer Type], [Service_Product Specific], [Service_Product Category]>} [Service_Services Type]), [Service_Services Type])"
                                        title="Services Type"
                                        toggleSelections
                                      />
                                    </div>         
                                    <div className={classes.filter}>
                                      <Filter
                                        field="=Aggr(Only({<[Service_Services Type], [Service_Customer Type], [Service_Product Specific], [Service_Product Category]>} [Service_Product Category]), [Service_Product Category])"
                                        title="Product Category"
                                        toggleSelections
                                      />
                                    </div>     
                                    <div className={classes.filter}>
                                      <Filter
                                        field="=Aggr(Only({<[Service_Services Type], [Service_Customer Type], [Service_Product Specific], [Service_Product Category]>} [Service_Product Specific]), [Service_Product Specific])"
                                        title="Product Specific"
                                        toggleSelections
                                      />
                                    </div> 
                                  </div>
                               }
                            </section>
                            {showTable &&
                            (
                              <div style={{display: 'flex', flexDirection: 'column', gap: '5px'}}>
                                <div className={classes.searchBar}>
                                  <Search searchString={servicesSearchString} setSearchString={this.setServicesSearchString} />
                                </div>
                                <TablePriceGuide
                                  selectedItems={selectedItems}
                                  type="services"
                                  clearTrigger={this.state.clearTrigger}
                                  searchString={servicesSearchString}
                                  showTable
                                  sortColumn={this.state.sortState.services.sortColumn}
                                  sortDirection={this.state.sortState.services.sortDirection}
                                  handleSort={this.handleSort}
                                />
                              </div>
                            )}
                          </div>
                        )}
                      </div>
    
                      <div className={classes.rightSide}>
                        <div
                          className={classes.drawer}
                          style={{
                            transform: drawerOpen ? 'translateX(0)' : 'translateX(100%)',
                          }}
                        >
                          {drawerOpen && (
                            <SelectedOffers
                              selectedItems={selectedItems}
                              updateItem={updateItem}
                              removeItem={removeItem}
                            />
                          )}
                        </div>
                      </div>
                    </section>
                  </div>
                  )
                }}
              </UserContext.Consumer>
            )}
          </SelectedOffersContext.Consumer>
        )}
      </div>
    );
  }
}

PriceGuideAlt.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default injectSheet(styles)(PriceGuideAlt);
